import InputField from '../input-field/InputField'
import DefaultButton from '../default-button/DefaultButton'
import Plus from '../../assets/icons/Plus'
import UploadDoc from '../../assets/icons/UploadDoc'

interface ScheduleControlProps {
  year: string
  semester: 'fall' | 'spring' | ''
  searchQuery: string
  onYearChange: (year: string) => void
  onSemesterChange: (sem: 'fall' | 'spring' | '') => void
  onSearchChange: (q: string) => void
  onCreate?: () => void,
  onUpload?: (e: any) => void,
}

export default function ScheduleControl({
  year,
  semester,
  searchQuery,
  onYearChange,
  onSemesterChange,
  onSearchChange,
  onCreate,
  onUpload
}: ScheduleControlProps) {
  return (
    <>
      <div className="flex w-full items-center justify-between gap-4 flex-wrap md:flex-nowrap">
        <div className="flex items-stretch gap-4 w-full md:w-auto flex-col sm:flex-row">
          <div className="text-valley-gray flex items-center gap-2">
            <div className="text-sm font-medium">
              Учебный год
            </div>
            <div className="w-fit min-w-[140px]">
              <InputField
                id="year"
                value={year}
                handleChange={(e: any) => onYearChange(e?.target?.value)}
                wrapperClassName="flex-1"
                type="select"
                additionalClassName="px-4 py-3 !bg-[#0068FF1F]/20 rounded-lg !placeholder-[#AFB7CA] mt-0 border-none w-fit"
                options={[
                  { value: "2025", label: "2025" },
                  { value: "2024", label: "2024" },
                  { value: "2023", label: "2023" }
                ]}
              />
            </div>
          </div>

          <div className="text-valley-gray flex items-center gap-2">
            <div className="text-sm font-medium">
              Семестр
            </div>
            <div className="w-fit min-w-[160px]">
              <InputField
                id="semester"
                value={semester}
                handleChange={(e: any) => onSemesterChange(e?.target?.value)}
                wrapperClassName="flex-1"
                type="select"
                additionalClassName="px-4 py-3 !bg-[#0068FF1F]/20 bg-opacity-20 rounded-lg !placeholder-[#AFB7CA] mt-0 border-none w-fit"
                options={[
                  { value: 'fall', label: "Осенний" },
                  { value: 'spring', label: "Весенний" },
                ]}
              />
            </div>
          </div>
        </div>

        <div className="flex flex-row w-full sm:w-auto gap-4">
          <label className='cursor-pointer items-center gap-1 py-1 border rounded-lg font-semibold flex flex-row w-full sm:w-auto border-valley-main text-valley-main px-3 text-nowrap max-h-fit justify-center'>
            <input onChange={onUpload} type='file' hidden />
            <UploadDoc />
            <span className='text text-valley-main text-sm'>
              Загрузить Excel
            </span>
          </label>
          {/* <DefaultButton
            additionalStyle="w-full sm:w-auto border-valley-dark-green text-valley-dark-green px-3 hover:bg-valley-dark-green hover:text-white text-nowrap"
            Icon={Plus}
            buttonText="Создать предмет"
            onClick={onCreate}
          /> */}
        </div>
      </div >

      <div className="mt-4 sm:mt-6">
        <InputField
          id="search"
          value={searchQuery}
          handleChange={(e: any) => onSearchChange(e?.target?.value)}
          wrapperClassName="flex-1"
          type="text"
          placeholder={'Поиск'}
          additionalClassName="px-4 py-3 !bg-[#F0F3FA] rounded-lg !placeholder-[#AFB7CA] mt-0 border-none"
        />
      </div>
    </>
  )
}